import React from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, Dropdown, Menu, Divider, Switch} from 'antd';
import getSize from "../../utils/getSize";
import NHFetch from "../../utils/NHFetch";
import NHTable from '../common/NHTable';
import {NHModal, NHConfirm} from '../common/NHModal';
import NHContainerFrame from '../common/NHContainerFrame';
import EditForm from './EditForm.js';
import ViewForm from './ViewForm.js';
import css from './index.css';
import {hasAuth} from "../../utils/NHCore";


const confirm = Modal.confirm;

/**
 * 学校信息列表
 * @author yizhiqiang
 * @Email yizhiqiang@ly-sky.com
 * @date 2018-03-02 14:00
 * Version: 1.0
 */
class TemplateTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap:{
                tableFlag:true,
                addFlag:false,
                updateFlag:false,
                showFlag:false,
            }
        };
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap=this.state.frameVisibleMap;
        for(let name in frameVisibleMap){
            if(name==showFlagName){
                frameVisibleMap[name]=true;
            }else{
                frameVisibleMap[name]=false;
            }
        }
        this.setState({
            frameVisibleMap:frameVisibleMap
        });
    }

    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setCurrentPageShow('addFlag');
    }
    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        let pkid = record.PKID;
        NHFetch('/face/' + pkid + '/get', 'GET')
            .then(res => {
                if(res){
                    this.setState({formInitData: res.data});
                    this.setCurrentPageShow('updateFlag');
                }
            })
    }
    //查看按钮点击事件
    handleViewBtnClick = (record) => {
        let pkid = record.PKID;
        NHFetch('/face/' + pkid + '/get', 'GET')
            .then(res => {
                if(res){
                    this.setState({formInitData: res.data});
                    this.setCurrentPageShow('showFlag');
                }
            })
    }
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
       NHConfirm("是否确定删除这条数据？",() => {
           let pkid = record.PKID;
           this.handleDelete([pkid]);
       },"warn");
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if(selectedRowKeys && selectedRowKeys.length>0){
            NHConfirm("是否确定删除选中的多条数据？",() => {
                this.handleDelete(selectedRowKeys);
            },"warn");
        }else{
            message.warning("请先选择需要删除的数据！");
        }
    }
    //删除操作
    handleDelete = (pkids) => {
        NHFetch('/face/deleteByMulti' , 'POST' , pkids)
            .then(res => {
                if (res) {
                    message.success("删除操作成功！");
                    this.refs.nhTable.filterTableData();
                }
            })
    }
    //新增面板保存方法
    handleSaveAdd = () => {
        this.refs.nhAddForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            NHFetch('/face/insert' , 'POST' , formData)
                .then(res => {
                    if (res) {
                        message.success("新增设置参数信息成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                    }
                })
        });
    }
    //修改面板保存方法
    handleSaveUpdate = () => {
        this.refs.nhUpdateForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            formData.pkid = this.state.formInitData.pkid;
            NHFetch('/face/update' , 'POST' , formData)
                .then(res => {
                    if (res) {
                        message.success("修改设置参数信息成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                    }
                })
        });
    }

    //启动按钮是否显示
    registerIsShow = (record) => {
        if(record.SFZC==='1'){
            return false;
        }else{
            return true;
        }
    }

    closeIsShow = (record) => {
        if(record.SFZC==='1'){
            return true;
        }else{
            return false;
        }
    }

    //人脸识别
    handleRlsbBtnClick = (record) => {
        window.open(window.location.href.split('#')[0]+"#/rlsb/"+record.PKID+"/"+record.IP);
    }

    //注册
    handleRegisterBtnClick = (record) => {
        NHFetch("api/zhxg-rlsb/yxxt/register/"+record.PKID,"POST")
            .then(res => {
                if (res) {
                    message.success("人脸识别注册成功！");
                    this.refs.nhTable.readTableData();
                }
            });
    }

    //关闭
    handleCloseBtnClick = (record) => {
        NHFetch("api/zhxg-rlsb/yxxt/close/"+record.PKID,"POST")
            .then(res => {
                if (res) {
                    message.success("人脸识别关闭成功！");
                    this.refs.nhTable.readTableData();
                }
            });
    }

    render() {
        //列参数
        const columns = [{
            title: '序号',
            width: '60px',
            dataIndex: 'ROW_ID'
        },{
            title: '标题',
            width: '260px',
            sorted:false,
            dataIndex: 'BT',
            searchType:"input"
        }, {
            title: '描述',
            minWidth: '150px',
            sorted:false,
            dataIndex: 'MS',
            searchType:"input"
        }, {
            title: 'IP地址',
            minWidth: '60px',
            sorted:false,
            dataIndex: 'IP',
            searchType:"input"
        }, {
            title: '端口',
            minWidth: '60px',
            sorted:false,
            dataIndex: 'DK',
            searchType:"input"
        }, {
            title: '是否启动',
            width: '100px',
            dataIndex: 'ZC',
            sorted:false,
            render: (text, record) => {
                    if(record.SFZC==='1'){
                        return <font style={{color:'green'}}>已启动</font>;
                    }else{
                        return <font style={{color:'red'}}>未启动</font>;
                    }
            }
        }];
        //行内操作
        const action = [
            {title:'人脸识别报到',onClick:this.handleRlsbBtnClick,auth:'zhxg_yxgl_rlsb:rlsb'},
            {title:'启动',onClick:this.handleRegisterBtnClick,auth:'zhxg_yxgl_rlsb:register'},
            {title:'关闭',onClick:this.handleCloseBtnClick,auth:'zhxg_yxgl_rlsb:close'},
            {title:'修改',onClick:this.handleUpdateBtnClick,auth:'zhxg_yxgl_rlsb:update'},
            {title:'删除',onClick:this.handleSingleDeleteBtnClick,auth:'zhxg_yxgl_rlsb:delete'},
            // {title:'查看',onClick:this.handleViewBtnClick,auth:'zhxg_yxgl_rlsb:view'},
        ];
        return (
            <div className={css.main_right_content} style={{height:getSize().windowH-123}}>
                <div className={css.table} style={{display:this.state.frameVisibleMap.tableFlag?'block':'none'}}>
                    <NHTable ref='nhTable'
                             rowKey={record =>record.PKID}
                             sign={"zhxg_yxxt_slcs_queryPage"}
                             columns={columns}
                             action={action}
                    >
                        {hasAuth('zhxg_yxgl_rlsb:add') ?<Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>: ''}
                        {hasAuth('zhxg_yxgl_rlsb:delete') ?<Button type="danger" ghost style={{marginLeft:10}} onClick={this.handleMultiDeleteBtnClick}>删除</Button>: ''}
                    </NHTable>
                </div>
                <NHContainerFrame ref="nhAddModal"
                         title="新增设置参数信息"
                         visible={this.state.frameVisibleMap.addFlag}
                         onOk={this.handleSaveAdd}
                         onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhAddForm"/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhUpdateModal"
                         title="修改设置参数信息"
                         visible={this.state.frameVisibleMap.updateFlag}
                         onOk={this.handleSaveUpdate}
                         onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhUpdateForm" editData={this.state.formInitData}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhShowModal"
                         visible={this.state.frameVisibleMap.showFlag}
                         title="查看设置参数信息"
                         onCancel={this.handleCloseFrame}
                >
                    <ViewForm editData={this.state.formInitData}/>
                </NHContainerFrame>
            </div>
        );
    }
}
export default TemplateTab;



// WEBPACK FOOTER //
// ./components/face/index.js